import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  Card,
  Row,
  Container,
  Button,
  Form,
  Spinner,
  Alert,
} from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import { useHistory } from "react-router-dom";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarConfig from "../../../components/SidebarDashboard";

import onBoardingPic from "../../../images/OnBoardingOffBoarding/onboarding3.png";
import onBoardingteachingPic from "../../../images/OnBoardingOffBoarding/teachings.png";
import { getDashBoardRespBoss } from "../../../redux/on&offBoarning/dashboardJefeResp/actions";
import "../../../css/onboarding.css";
import moment from "moment";
const DashboardOnOfffBoarding = (props) => {
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [dat, setDat] = useState(
    `${moment().format("YYYY")}-${moment().format("MM")}-01`
  );
  const dispatch = useDispatch();
  const { dashboardData, loader } = useSelector(
    (store) => store.dashBoardRespBoss
  );

  const userRoles = useSelector((store) => store.auth.userRoles);

  const history = useHistory();

  useEffect(() => {
    if (isNaN(props.match.params.tipoWorkflow)) {
      let valor = props.match.params.tipoWorkflow.toLowerCase();
      switch (valor) {
        case "onboarding":
          // history.push("/Dashboard/OnBoarding");
          history.push("/Indicador/OnBoarding");
          // dispatch(getDashBoardRespBoss({fecha: dat}));
          dispatch(
            getDashBoardRespBoss({ fecha: dat, tipo_workflow: parseInt(1) })
          );
          break;
        case "offboarding":
          // history.push("/Dashboard/OffBoarding");
          history.push("/Indicador/OffBoarding");
          dispatch(
            getDashBoardRespBoss({ fecha: dat, tipo_workflow: parseInt(2) })
          );
          break;
        default:
          history.goBack();
          break;
      }
    } else {
      history.goBack();
    }
  }, [dispatch, dat, props.match.params.tipoWorkflow]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    setDat(
      `${moment(e.target.fecha_min.value).format("YYYY")}-${moment(
        e.target.fecha_min.value
      ).format("MM")}-01`
    );
  };

  const encuestasMensualData = {
    labels: dashboardData.labels,
    datasets: dashboardData.dataset,
  };

  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        {userRoles &&
        userRoles.find(
          (u) =>
            u.replace("Responsable_", "") === props.match.params.tipoWorkflow ||
            u === "jefe" ||
            u === "administrador"
        ) === undefined ? (
          <Alert variant="danger" className="mt-4 mb-1 mx-3">
            Su perfil no puede visualizar los {props.match.params.tipoWorkflow}!
          </Alert>
        ) : (
          <Container fluid>
            <Col md={12}>
              <Card className="border-0">
                <Card.Body>
                  <Row>
                    <Col md="4" className="mb-2 mb-sm-0">
                      <Card className="d-flex flex-wrap justify-content-between align-items-between">
                        <Card.Body
                          className="dashboard-card oActivos shadow rounded d-flex flex-wrap justify-content-between align-items-between"
                          style={{ border: "1px solid #ced4da" }}
                        >
                          {loader ? (
                            <div className="d-flex justify-content-center w-100">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Col className="m-0">
                                <Col
                                  sm="12"
                                  md="12"
                                  lg="12"
                                  xl="12"
                                  className="d-flex flex-wrap justify-content-center align-items-center pb-1 pt-1 mb-1"
                                >
                                  <p className="title2">
                                    <span className="font-weight-bold title2">
                                      {props.match.params.tipoWorkflow} activos
                                    </span>
                                  </p>
                                </Col>
                                {/* {loading ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : monitor && monitor.sumatoria_encuestas_aplicadas ? (
                            <>
                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {Number(monitor.sumatoria_encuestas_aplicadas)}
                                  </h1>
                                  <i className="material-icons icon pr-3 m-auto">
                                    ballot
                                  </i>
                                </Row>
                              </Col>

                              <p className="footer2">
                                <span className="font-weight-bold footer2">
                                  {Number(
                                    monitor.porcentaje_encuestas_aplicadas_vrs_año_pasado.toFixed(
                                      2
                                    )
                                  )}
                                  % vs año anterior
                                </span>
                              </p>
                            </>
                          ) : (
                            <> */}
                                <Col sm="12" md="12" lg="12" xl="12">
                                  <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                    <h1 className="font-weight-bold title2 m-auto">
                                      {dashboardData.monitor_WF
                                        ? dashboardData.monitor_WF.activos
                                        : 0}
                                    </h1>
                                  </Row>
                                </Col>

                                <Col
                                  sm="12"
                                  md="12"
                                  lg="12"
                                  xl="12"
                                  className="d-flex flex-wrap justify-content-center align-items-center"
                                >
                                  <p className="footer2">
                                    <span className="font-weight-bold footer2">
                                      {dashboardData.monitor_WF
                                        ? dashboardData.monitor_WF.porcentaje_activos_vrs_año_pasado.toFixed(
                                            2
                                          )
                                        : 0}
                                      % vs año anterior
                                    </span>
                                  </p>
                                </Col>
                                {/* </>
                          )} */}
                              </Col>
                              <Col
                                md="2"
                                className="d-flex flex-wrap justify-content-center align-items-center pl-0"
                              >
                                <img
                                  src={onBoardingPic}
                                  alt="Imagen OffBoarding"
                                  className="m-auto"
                                  style={{
                                    marginRight: "1rem",
                                    display: "inline-block",
                                    width: "80px",
                                  }}
                                ></img>
                              </Col>
                            </>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md="8" className="mb-2 mb-sm-0">
                      <Card className="d-flex flex-wrap justify-content-between align-items-between">
                        <Card.Body
                          className="dashboard-card oActuales shadow rounded d-flex flex-wrap justify-content-between align-items-between"
                          style={{ border: "1px solid #ced4da" }}
                        >
                          {loader ? (
                            <div className="d-flex justify-content-center w-100">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Col>
                                <Row>
                                  <Col
                                    sm="12"
                                    md="12"
                                    lg="12"
                                    xl="12"
                                    className="d-flex flex-wrap justify-content-center align-items-center pb-1 pt-1 mb-1"
                                    // style={{ borderBottom: "1px solid #ced4da" }}
                                  >
                                    <p className="m-0">
                                      <span className="font-weight-bold">
                                        Cumplimiento de actividades
                                      </span>
                                    </p>
                                  </Col>
                                  <Col>
                                    {/* {loading ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : monitor && monitor.sumatoria_encuestas_aplicadas ? (
                            <>
                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {Number(monitor.encuestas_activas_del_mes)}
                                  </h1>
                                  <i className="material-icons icon pr-3 m-auto">
                                    event_available
                                  </i>
                                </Row>
                              </Col>

                              <p className="footer2">
                                <span className="font-weight-bold footer2">
                                  <span>
                                    {Number(
                                      monitor.porcentaje_encuestas_activas_vrs_mes_pasado.toFixed(
                                        2
                                      )
                                    )}
                                    %
                                  </span>{" "}
                                  vs mes pasado
                                </span>
                              </p>
                            </>
                          ) : (
                            <> */}
                                    <Col sm="12" md="12" lg="12" xl="12">
                                      <Row className="pl-3 d-flex flex-wrap justify-content-center align-items-center">
                                        <h1 className="font-weight-bold title2 m-auto">
                                          {dashboardData.monitor_WF
                                            ? dashboardData.monitor_WF
                                                .inducciones_actuales_total
                                            : 0}
                                        </h1>
                                      </Row>
                                    </Col>

                                    <p className="footer2 mt-0 d-flex flex-wrap justify-content-center align-items-center">
                                      <span className="font-weight-bold footer2">
                                        Total
                                      </span>
                                    </p>
                                    {/* </>
                          )} */}
                                  </Col>
                                  <Col>
                                    {/* {loading ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : monitor && monitor.sumatoria_encuestas_aplicadas ? (
                            <>
                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {Number(monitor.encuestas_activas_del_mes)}
                                  </h1>
                                  <i className="material-icons icon pr-3 m-auto">
                                    event_available
                                  </i>
                                </Row>
                              </Col>

                              <p className="footer2">
                                <span className="font-weight-bold footer2">
                                  <span>
                                    {Number(
                                      monitor.porcentaje_encuestas_activas_vrs_mes_pasado.toFixed(
                                        2
                                      )
                                    )}
                                    %
                                  </span>{" "}
                                  vs mes pasado
                                </span>
                              </p>
                            </>
                          ) : (
                            <> */}
                                    <Col sm="12" md="12" lg="12" xl="12">
                                      <Row className="pl-3 d-flex flex-wrap justify-content-center align-items-center">
                                        <h1 className="font-weight-bold title2 m-auto">
                                          {dashboardData.monitor_WF
                                            ? dashboardData.monitor_WF
                                                .inducciones_actuales_finalizado
                                            : 0}
                                        </h1>
                                      </Row>
                                    </Col>

                                    <p className="footer2 mt-0 d-flex flex-wrap justify-content-center align-items-center">
                                      <span className="font-weight-bold footer2">
                                        Finalizado
                                      </span>
                                    </p>
                                    {/* </>
                          )} */}
                                  </Col>
                                  <Col>
                                    {/* {loading ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : monitor && monitor.sumatoria_encuestas_aplicadas ? (
                            <>
                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {Number(monitor.encuestas_activas_del_mes)}
                                  </h1>
                                  <i className="material-icons icon pr-3 m-auto">
                                    event_available
                                  </i>
                                </Row>
                              </Col>

                              <p className="footer2">
                                <span className="font-weight-bold footer2">
                                  <span>
                                    {Number(
                                      monitor.porcentaje_encuestas_activas_vrs_mes_pasado.toFixed(
                                        2
                                      )
                                    )}
                                    %
                                  </span>{" "}
                                  vs mes pasado
                                </span>
                              </p>
                            </>
                          ) : (
                            <> */}
                                    <Col sm="12" md="12" lg="12" xl="12">
                                      <Row className="pl-3 d-flex flex-wrap justify-content-center align-items-center">
                                        <h1 className="font-weight-bold title2 m-auto">
                                          {dashboardData.monitor_WF
                                            ? dashboardData.monitor_WF
                                                .inducciones_actuales_atrasadas
                                            : 0}
                                        </h1>
                                      </Row>
                                    </Col>

                                    <p className="footer2 mt-0 d-flex flex-wrap justify-content-center align-items-center">
                                      <span className="font-weight-bold footer2">
                                        Atrasado
                                      </span>
                                    </p>
                                    {/* </>
                          )} */}
                                  </Col>
                                  <Col>
                                    {/* {loading ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : monitor && monitor.sumatoria_encuestas_aplicadas ? (
                            <>
                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {Number(monitor.encuestas_activas_del_mes)}
                                  </h1>
                                  <i className="material-icons icon pr-3 m-auto">
                                    event_available
                                  </i>
                                </Row>
                              </Col>

                              <p className="footer2">
                                <span className="font-weight-bold footer2">
                                  <span>
                                    {Number(
                                      monitor.porcentaje_encuestas_activas_vrs_mes_pasado.toFixed(
                                        2
                                      )
                                    )}
                                    %
                                  </span>{" "}
                                  vs mes pasado
                                </span>
                              </p>
                            </>
                          ) : (
                            <> */}
                                    <Col sm="12" md="12" lg="12" xl="12">
                                      <Row className="pl-3 d-flex flex-wrap justify-content-center align-items-center">
                                        <h1 className="font-weight-bold title2 m-auto">
                                          {dashboardData.monitor_WF
                                            ? dashboardData.monitor_WF
                                                .inducciones_actuales_pendiente
                                            : 0}
                                        </h1>
                                      </Row>
                                    </Col>

                                    <p className="footer2 mt-0 d-flex flex-wrap justify-content-center align-items-center">
                                      <span className="font-weight-bold footer2">
                                        Pendiente
                                      </span>
                                    </p>
                                    {/* </>
                          )} */}
                                  </Col>
                                </Row>
                              </Col>
                              <Col
                                md="2"
                                className="mt-0 d-flex flex-wrap justify-content-center align-items-center"
                              >
                                <img
                                  src={onBoardingteachingPic}
                                  alt="Imagen OffBoarding"
                                  className="m-auto"
                                  style={{
                                    marginRight: "1rem",
                                    display: "inline-block",
                                    width: "80px",
                                  }}
                                ></img>
                              </Col>
                            </>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Row className="mx-4">
              <Col sm={12}>
                <Row className="align-items-end">
                  <Col sm={12} className="mt-2">
                    <Form
                      onSubmit={handleSubmit}
                      noValidate
                      validated={validated}
                    >
                      <Form.Group>
                        <Form.Label className="ml-2">
                          Fecha de actividades:
                        </Form.Label>
                        <Row>
                          <Col sm={4}>
                            <Form.Control
                              name="fecha_min"
                              className="rounded-pill"
                              required
                              type="date"
                              defaultValue={dat}
                              // defaultValue={fechaInicio}
                              //onChange={event => setFechaMin(event.target.value)}
                              // defaultValue={ edit ? editItem.saldo_vacaciones : null}
                              placeholder="fecha inicial"
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              **Este campo es requerido
                            </Form.Control.Feedback>
                          </Col>
                          {/*  <Col sm={4}>
                          <Form.Control
                            name="fecha_max"
                            className="rounded-pill"
                            required
                            type="date"
                            // defaultValue={fechaFin}
                            //onChange={event => setFechaMax(event.target.value)}
                            // defaultValue={ edit ? editItem.saldo_vacaciones : null}
                            placeholder="fecha final"
                          ></Form.Control>
                          <Form.Control.Feedback type="invalid">
                            **Este campo es requerido
                          </Form.Control.Feedback>
                        </Col> */}
                          <Col sm={4}>
                            <Button
                              type="submit"
                              variant="primary"
                              size="md"
                              block
                            >
                              <b>Filtrar datos</b>
                            </Button>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Form>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Col md={12}>
              <Row className="my-3 ml-2 mr-2">
                <Col md="12" className="mb-3 mb-sm-0">
                  <Card
                    className="shadow"
                    style={{ border: "1px solid #ced4da" }}
                  >
                    <Card.Body>
                      <h5 className="text-muted">
                        Cumplimiento de Actividades
                      </h5>
                      {loader ? (
                        <div className="d-flex justify-content-center w-100">
                          <Spinner
                            animation="border"
                            role="status"
                            className="d-flex justify-content-center"
                          />
                        </div>
                      ) : (
                        <Bar
                          height={155}
                          data={encuestasMensualData}
                          options={{
                            fill: false,
                            interaction: {
                              intersect: false,
                            },
                            responsive: true,
                            legend: {
                              display: false,
                            },
                            // scales:{
                            //   x:{ stacked: true},
                            //   y:{ stacked: true}
                            // },
                            radius: 0,
                          }}
                        />
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Container>
        )}
      </div>
    </>
  );
};

export default DashboardOnOfffBoarding;
